var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"app"}},[_c('header',[_c('img',{attrs:{"src":"assets/img/b3-quiz-visual.png","alt":"BAYERN 3 Quiz"}})]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }